import React from 'react';
import PropTypes from 'prop-types';

import { CloseBtn } from '@meronex/components';
import IosPeople from '@meronex/icons/ios/IosPeople';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import RolesSelect from './RolesSelect';
import MembersList from './MembersList';
import TopHeader from '../../../views/components/TopHeader';

function MembersDialog(props) {
  const { open, onClose } = props;

  const [filterValue, setFilterValue] = React.useState();
  const [filters, setFilters] = React.useState({});
  const [openAddMemberDialog, setOpenAddMemberDialog] = React.useState(false);

  React.useEffect(() => {
    setFilters({
      textFilter: filterValue,
      roleFilter: filters.roleFilter,
    });
  }, [filterValue]);

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <TopHeader
          title={'Members'}
          onClose={onClose}
          icon={<IosPeople />}
          actionLabel={'Add Member'}
          onAction={() => setOpenAddMemberDialog(true)}
          filterProps={{
            placeholder: 'Filter by name or email',
            expandable: true,
            showApply: false,
            height: 140,
            onFilter: (v) => {
              setFilterValue(v);
            },
            onReset: () => {
              setFilters({
                textFilter: '',
                roleFilter: null,
              });
            },
            onApply: () => {},
            filterValue: (v) => {},
            extraFields: (
              <div>
                <RolesSelect
                  defaultValue={'any'}
                  onChange={(v) => {
                    setFilters({
                      textFilter: filterValue,
                      roleFilter: v.target.value,
                    });
                  }}
                />
              </div>
            ),
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0px' }}>
        <MembersList
          filters={filters}
          openAddDialog={openAddMemberDialog}
          onAddDialogClose={() => setOpenAddMemberDialog(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
MembersDialog.defaultProps = {
  open: false,
  onClose: () => {},
};
MembersDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default MembersDialog;
